import { Client, Interceptors } from '../../fetch'
import * as URLUtils from '../../lib/url'
import LOCALE from '@avcan/constants/locales'

export default class AdminClient {
    constructor(url, key) {
        this.client = new Client(url, new Interceptors.CacheKey(), new Interceptors.APIKey(key))
    }
    getUserInfo(getToken) {
        return this.client.get(['users', 'info'], getToken)
    }
    getUsers(username, page, getToken) {
        const path = URLUtils.appendParams('users', { username, page })

        return this.client.get(path, getToken)
    }
    changeUsername(userId, username, locale = LOCALE, getToken) {
        const path = ['users', encodeURIComponent(userId)]
        const config = { 'Accept-Language': locale }

        return this.client.patch(path, { username }, getToken, config)
    }
}
